<template>
    <transition name="fade">
        <div class="quiz-setting-modal modal">
            <div class="modal-backdrop" @click="closeModal"></div>
            <div class="modal-content relative">
                <div class="modal-header flex">
                    <div class="font-size-20 sm:text-center font-bold w-full">
                        {{ $t('playlive_setting_modal_header') }}
                    </div>
                    <div class="x-btn cursor-pointer" @click="closeModal">
                        <i class="fas fa-times"></i>
                    </div>
                </div>
                <div class="modal-body mb-4">
                    <div class="ml-2 mt-2 mb-4">
                        <div class="font-size-18 font-bold mb-3">
                            {{ $t('playlive_setting_modal_header_setting') }}
                        </div>
                        <div class="flex mb-2 items-center">
                            <div class="flex mr-2">
                                <div @click="minusValue('answer')" class="btn-style" :class="{ disabled: answer == 0 }">
                                    <i class="fas fa-minus"></i>
                                </div>
                                <div class="input-value">
                                    {{ answer }}
                                </div>
                                <div @click="plusValue('answer')" class="btn-style" :class="{ disabled: answer == 15 }">
                                    <i class="fas fa-plus"></i>
                                </div>
                            </div>
                            <div id="delay-choice">
                                {{ $t('playlive_setting_modal_delay_choice') }}
                            </div>
                        </div>
                        <div
                            @click="toggleLimitTime"
                            class="flex cursor-pointer mb-1"
                            style="width: fit-content"
                            id="time-limit"
                        >
                            <XCheckbox
                                @input="toggleLimitTime"
                                :checked="!limitTime"
                                name="timeLimit"
                                size="md"
                                type="checkbox"
                                theme="red"
                                class="mr-1"
                            ></XCheckbox>
                            {{ $t('playlive_setting_modal_time_limit') }}
                        </div>
                        <div v-if="limitTime" class="flex mb-2 items-center">
                            <div class="flex mr-2">
                                <div
                                    @click="minusValue('question')"
                                    :class="{ disabled: question == 20 }"
                                    class="btn-style"
                                >
                                    <i class="fas fa-minus"></i>
                                </div>
                                <div class="input-value">
                                    {{ question }}
                                </div>
                                <div
                                    @click="plusValue('question')"
                                    :class="{ disabled: question == 60 }"
                                    class="btn-style"
                                >
                                    <i class="fas fa-plus"></i>
                                </div>
                            </div>
                            <div>
                                {{ $t('playlive_setting_modal_delay_question') }}
                            </div>
                        </div>
                    </div>
                    <div class="ml-2 mb-4">
                        <div class="font-size-18 font-bold mb-3">
                            {{ $t('playlive_setting_modal_header_quizmaster_device') }}
                        </div>
                        <div
                            @click="toggleMasterSound('questionMusic', !master.questionMusic)"
                            class="flex cursor-pointer"
                        >
                            <XCheckbox
                                @input="toggleMasterSound('questionMusic', !master.questionMusic)"
                                :checked="master.questionMusic"
                                name="masterQuestion"
                                size="md"
                                type="checkbox"
                                theme="red"
                                class="mr-1"
                            ></XCheckbox>
                            {{ $t('playlive_setting_modal_sound_question_toggle1') }}
                        </div>
                        <div class="flex cursor-pointer" @click="toggleMasterSound('effectMusic', !master.effectMusic)">
                            <XCheckbox
                                @input="toggleMasterSound('effectMusic', !master.effectMusic)"
                                :checked="master.effectMusic"
                                name="masterEffect"
                                size="md"
                                type="checkbox"
                                theme="red"
                                class="mr-1"
                            ></XCheckbox>
                            {{ $t('playlive_setting_modal_sound_join_answer') }}
                        </div>
                        <div
                            @click="toggleMasterResultSetting('playerAnswersBox', !masterResult.playerAnswersBox)"
                            class="flex cursor-pointer mt-4"
                        >
                            <XCheckbox
                                @input="toggleMasterResultSetting('playerAnswersBox', !masterResult.playerAnswersBox)"
                                :checked="masterResult.playerAnswersBox"
                                name="resultPlayerAnswersBox"
                                size="md"
                                type="checkbox"
                                theme="red"
                                class="mr-1"
                            ></XCheckbox>
                            Show players answers
                        </div>
                        <div class="flex cursor-pointer" @click="toggleMasterResultSetting('icon', !masterResult.icon)">
                            <XCheckbox
                                @input="toggleMasterResultSetting('icon', !masterResult.icon)"
                                :checked="masterResult.icon"
                                name="resultIcon"
                                size="md"
                                type="checkbox"
                                theme="red"
                                class="mr-1"
                            ></XCheckbox>
                            Show players correct/wrong icon
                        </div>
                        <div
                            class="flex cursor-pointer"
                            @click="toggleMasterResultSetting('topPlayerBox', !masterResult.topPlayerBox)"
                        >
                            <XCheckbox
                                @input="toggleMasterResultSetting('topPlayerBox', !masterResult.topPlayerBox)"
                                :checked="masterResult.topPlayerBox"
                                name="resultTopPlayerBox"
                                size="md"
                                type="checkbox"
                                theme="red"
                                class="mr-1"
                            ></XCheckbox>
                            Show "Top 3 rank" box
                        </div>
                        <div
                            @click="toggleMasterResultSetting('bgBox', !masterResult.bgBox)"
                            class="flex cursor-pointer"
                        >
                            <XCheckbox
                                @input="toggleMasterResultSetting('bgBox', !masterResult.bgBox)"
                                :checked="masterResult.bgBox"
                                name="resultBgBox"
                                size="md"
                                type="checkbox"
                                theme="red"
                                class="mr-1"
                            ></XCheckbox>
                            Background boxes
                        </div>
                    </div>
                    <div class="ml-2">
                        <div class="font-size-18 font-bold mb-3">
                            {{ $t('playlive_setting_modal_header_player_device') }}
                        </div>
                        <div
                            @click="togglePlayerSound('questionMusic', !player.questionMusic)"
                            class="flex cursor-pointer"
                        >
                            <XCheckbox
                                @input="togglePlayerSound('questionMusic', !player.questionMusic)"
                                :checked="player.questionMusic"
                                name="playerQuestion"
                                size="md"
                                type="checkbox"
                                theme="red"
                                class="mr-1"
                            ></XCheckbox>
                            {{ $t('playlive_setting_modal_sound_question_toggle2') }}
                        </div>
                        <div class="flex cursor-pointer" @click="togglePlayerSound('effectMusic', !player.effectMusic)">
                            <XCheckbox
                                @input="togglePlayerSound('effectMusic', !player.effectMusic)"
                                :checked="player.effectMusic"
                                name="playerEffect"
                                size="md"
                                type="checkbox"
                                theme="red"
                                class="mr-1"
                            ></XCheckbox>
                            {{ $t('playlive_setting_modal_sound_correct_wrong_toggle') }}
                        </div>
                        <div class="flex cursor-pointer" @click="toggleShowProgressBar()">
                            <XCheckbox
                                @input="toggleShowProgressBar"
                                :checked="showProgressBar"
                                name="playerProgressBar"
                                size="md"
                                type="checkbox"
                                theme="red"
                                class="mr-1"
                            ></XCheckbox>
                            {{ $t('playlive_setting_modal_show_progress_bar') }}
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <div
                        @click="closeModal"
                        class="close-btn cursor-pointer font-bold system-button-color system-button-text-color"
                    >
                        {{ $t('playlive_setting_modal_button_close') }}
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
import { mapGetters } from 'vuex'
import XCheckbox from '@/components/v2/XCheckbox.vue'
import IntroHint from '@/lib/intro.js'
import introJsData from '@/mixins/introjs-data'

export default {
    name: 'QuizSettingModal',

    components: {
        XCheckbox
    },

    mixins: [introJsData],

    props: {
        delayAnswer: Number,
        delayQuestion: Number,
        timeLimit: Boolean,
        masterSound: Object,
        playerSound: Object,
        progressBarStatus: Boolean,
        masterResultSetting: Object
    },

    data() {
        return {
            answer: 0,
            question: 0,
            limitTime: false,
            showProgressBar: false,
            master: {
                questionMusic: true,
                effectMusic: true
            },
            player: {
                questionMusic: true,
                effectMusic: true
            },
            masterResult: {
                playerAnswersBox: true,
                icon: true,
                topPlayerBox: true,
                bgBox: true
            },
            introHint: new IntroHint()
        }
    },

    computed: {
        ...mapGetters({
            masterQuestion: 'getMasterQuestion',
            masterEffect: 'getMasterEffect',
            playerQuestion: 'getPlayerQuestion',
            playerEffect: 'getPlayerEffect'
        })
    },

    mounted() {
        this.answer = this.delayAnswer
        this.question = this.delayQuestion
        this.limitTime = this.timeLimit
        this.master = this.masterSound
        this.player = this.playerSound
        this.showProgressBar = this.progressBarStatus
        this.masterResult = this.masterResultSetting

        setTimeout(() => {
            this.introHint.register(this.hintsLiveSettings)
        }, 500)
    },

    methods: {
        minusValue(type) {
            if (type == 'answer' && this[type] == 0) {
                this[type] == 0
            } else if (type == 'question' && this[type] == 20) {
                this[type] == 10
            } else {
                this[type] = this[type] - 1
            }
        },

        plusValue(type) {
            if (type == 'answer' && this[type] == 15) {
                this[type] == 15
            } else if (type == 'question' && this[type] == 60) {
                this[type] == 60
            } else {
                this[type] = this[type] + 1
            }
        },

        toggleLimitTime() {
            this.limitTime = !this.limitTime
        },

        toggleMasterSound(name, val) {
            this.master[name] = val
        },

        togglePlayerSound(name, val) {
            this.player[name] = val
        },

        toggleShowProgressBar() {
            this.showProgressBar = !this.showProgressBar
        },

        toggleMasterResultSetting(name, val) {
            this.masterResult[name] = val
        },

        closeModal() {
            this.$emit(
                'close',
                this.answer,
                this.question,
                this.limitTime,
                this.master,
                this.player,
                this.showProgressBar,
                this.masterResult
            )

            this.introHint.removeHints()
        }
    }
}
</script>

<style lang="scss" scoped>
.quiz-setting-modal {
    .modal-backdrop {
        background-color: rgba(0, 0, 0, 0.2);
        width: 100%;
        height: 100%;
        position: fixed;
        top: 0;
        left: 0;
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 9999;
        overflow: auto;
        z-index: -1;
    }

    .modal-content {
        background-color: #fff;
        padding: 1rem;
        min-width: 550px;
        overflow: hidden;
        border-radius: 4px;
        box-shadow: 2px 2px 20px rgba(0, 0, 0, 0.6);

        @media (max-width: 575px) {
            min-width: 95%;
        }

        .modal-header {
            padding: 0.5rem 0.5rem 1rem;
            border-bottom: 1px solid red;
        }

        .x-btn {
            position: absolute;
            right: 1rem;
            top: 1rem;

            i {
                font-size: 1.5rem;
                text-shadow: none;
            }
        }

        .modal-footer {
            display: flex;
            justify-content: flex-end;

            .close-btn {
                padding: 0.5rem 0.8rem;
                width: fit-content;
                background-color: #000;
                color: #fff;
                border-radius: 4px;
            }
        }

        .btn-style {
            display: flex;
            justify-content: center;
            align-items: center;
            width: 30px;
            height: 30px;
            cursor: pointer;

            i {
                text-shadow: none;
                color: #ef0000;
                // color: #999999;
            }

            &.disabled {
                cursor: not-allowed;

                i {
                    color: #999999;
                }
            }
        }

        .input-value {
            width: 38px;
            height: 30px;
            display: flex;
            justify-content: center;
            align-items: center;
        }
    }
}
</style>